import { merge as lodashMerge, cloneDeep as lodashCloneDeep } from "lodash"

export const merge = lodashMerge
export const clone = lodashCloneDeep

export const callAll =
	(...fns: Array<Function>) =>
	(...args: any) =>
		// oxlint-disable-next-line typescript/no-unsafe-return
		fns.forEach((fn) => fn?.(...args))

// replace all non alphanunberic characters with an underscore
// replace all spaces with an underscore
export function normaliseString(value: string) {
	return value
		.replace(/[^a-z0-9]/gim, "")
		.replace(/\s+/g, "_")
		.toLowerCase()
}
